import React from "react";
import useTableData from "./useTableData";
import ListViewCommon from "./ListViewCommon";

const headers = [
    {"label": "Typ", 'filter': 'string'},
    {"label": "Nazov", 'caption': "Názov", 'filter': 'string'},
    {"label": "Produktova_Skupina", 'caption': "Produktová skupina", 'filter': 'string'},
    {"label": "Vyrobca", 'caption': "Výrobca", 'filter': 'string'}
]

function Products(props) {
    const initialFilters = [
        {
            'label': 'Typ',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Nazov',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Vyrobca',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Produktova_Skupina',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Meno',
        }
    ]

    const baseUrl = '/product/products'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'Typ': `/products/product/${entry.id}`
        }))
    }

    return (
        <ListViewCommon baseUrlFrontend={`/products/product`}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Produkty"}
        />
    )
}

export default Products
